<template>
	<div class="portal-ad">
		<el-header class="userQueryHeader" height="32px">
			<div class="userQueryHeader-wrap"><span>个人数据中心配置</span></div>
		</el-header>
		<el-main>
			<sw-table
				:pagination="false"
				:tableName="'sw-table-example-1'"
				:tableData="tableData"
				:tableTitle="tableTitle"
				:tableOperation="tableOperation1"
				@operation-handle="operationHandle"
				row-key="index"
			></sw-table>

			<div style="height: 200px;width: 100%;"></div>

			<!-- <el-table :data="tableData" border style="width: 100% " stripe>
				<el-table-column prop="name" label="姓名"></el-table-column>
				<el-table-column fixed="right" label="操作" width="100">
					<template slot-scope="scope">
						<el-button @click="handleClick(scope.row)" type="text"><i class="el-icon-delete"></i></el-button>
						<el-button type="text"><i class="el-icon-edit"></i></el-button>
					</template>
				</el-table-column>
			</el-table> -->
		</el-main>
	</div>
</template>

<script>
	import { getPersonalCenter} from '@/api/personal.js'
export default {
	data() {
		return {
			tableData: [],
			tableTitle: [
				// {prop:'date',label:'时间',width:'120',sortable:true},
				{ prop: 'name', label: '名称', width: '120', sortable: false },
				{ prop: 'jiekoutype', label: '接口类型', width: '120', sortable: false },
				{ prop: 'urlLink', label: '跳转地址', width: '120', sortable: false },
				// {prop:'address',label:'地址',width:'120',sortable:false},
			],
			tableOperation1: [
				// { name: '详情', icon: 'su-icon-details', operation: 'detail' },
				{ name: '编辑', icon: 'su-icon-edit', operation: 'edit', className: 'testgreen' },
				// { name: '删除', icon: 'su-icon-delete', operation: 'delete' }
				// { name: '冻结', operation: 'freeze' }
			]
		};
	},
	created() {
		this.handleTableData();
	},
	methods: {
		handleTableData(){
			getPersonalCenter().then((res) => {
				console.log(res.data)
				this.tableData = res.data.list
			})
		},
		
		operationHandle(id, operation, row) {
			//this._data[`${operation}VisibleTable`]=!this._data[`${operation}VisibleTable`];//当需要弹窗时可以使用这行代码
			// this.$confirm(id + ',' + operation);
			if (this[`${operation}Handle`]) {
				this[`${operation}Handle`](id, operation, row);
			}
		},
		editHandle(id, operation, row) {
			console.log(row.name);
			this.$router.push({
				name: 'detailEdit',
				query: {
					type : row.id
				}
			})

		},
		deleteHandle(id, operation, row) {
			console.log(row.name);
		}
	}
};
</script>

<style lang="scss" scoped>
.portal-ad {
	margin-left: 50px;
	min-width: 1000px;
	height: calc(100vh - 100px);
	.userQueryHeader {
		background: #f4f8fc;
		box-shadow: 0px -2px 3px rgba($color: #e7e7e7, $alpha: 0.5) inset;
		span {
			font-size: 12px;
			line-height: 32px;
			padding: 0 2px;
		}
		&-wrap {
			span {
				padding-left: 7px;
				border-left: 3px solid #3394e1;
				color: rgba(2, 21, 37, 0.45);
			}
		}
	}
}
// /deep/ .sw-table-no-ellipsis{
// 	opacity: 0;
// }
</style>